import { useState, useEffect, useRef } from 'react';

const PLACEHOLDER_IMG = 'https://images.unsplash.com/photo-1631856956334-35db20cb7748?w=400&h=300&fit=crop';

export default function LazyImage({ src, alt, className, ...props }) {
  const [loaded, setLoaded] = useState(false);
  const [inView, setInView] = useState(false);
  const [error, setError] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );
    if (imgRef.current) observer.observe(imgRef.current);
    return () => observer.disconnect();
  }, []);

  const finalSrc = error ? PLACEHOLDER_IMG : (src || PLACEHOLDER_IMG);

  return (
    <div ref={imgRef} className={`relative overflow-hidden ${className || ''}`} {...props}>
      {!loaded && (
        <div className="absolute inset-0 bg-neutral-200 dark:bg-neutral-700 animate-pulse" />
      )}
      {inView && (
        <img
          src={finalSrc}
          alt={alt}
          className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => setLoaded(true)}
          onError={() => { setError(true); setLoaded(true); }}
        />
      )}
    </div>
  );
}
